import React from 'react'
import github from '../assets/icons/github.svg'
import pin from '../assets/icons/pin.svg'
import tie from '../assets/icons/tie.svg'
import resume from '../assets/Kuldeep_Singh_Resume.pdf'

const Sidebar = () => {
    const handleEmailMe = () => {
        window.open("mailto:kuldeepdawar47@gmail.com")
    }
    return (
        <div className="sidebar">
            <img src="/images/k2.jpeg" alt="image" className="sidebar__avatar" />
            <div className="sidebar__name">Kuldeep <span>Singh</span> </div>
            <div className="sidebar__item sidebar__title">React Developer</div>
            <a href={resume} download="Kuldeep_Singh_Resume.pdf">
                <div className="sidebar__item sidebar__resume">
                    <img src={tie} alt="resume" className="sidebar__icon" />Download Resume
                </div>
            </a>
            <figure className="sidebar__social-icons my-2">
                <a href="https://www.linkedin.com/in/kuldeepdawar/">LinkedIn</a>
            
            </figure>
            <div className="sidebar__contact">
                <div className="sidebar__item sidebar__github">
                    <a href="https://github.com/kuldeepdawar"><img src={github} alt="github" className="sidebar__icon mr-3" />github</a>
                </div>
                <div className="sidebar__location">
                    <img src={pin} alt="location" className="sidebar__icon mr-3" />
                    Melbourne, Australia</div>
                <div className="sidebar__item">kuldeepdawar47@gmail.com</div>
                <div className="sidebar__item">0452492629</div>
            </div>
            <div className="sidebar__item sidebar__email" onClick={handleEmailMe}>Email</div>
        </div>
    )
}

export default Sidebar;